/**
 * AndroidInterfaceWrapper
 *
 * 该模块封装了与安卓应用通信的接口方法，包括展示Toast消息和获取数据。
 */
const AndroidInterfaceWrapper = ((androidConfig) => {
  /**
   * 调用安卓的指定方法，并通过回调函数处理返回的数据
   * @param {Object} androidConfig - 包含安卓接口对象和方法名的配置对象
   * @param {Function} callback - 回调函数，用于处理安卓端返回的数据
   */
  const callAndroidMethod = (androidConfig, params, callback) => {
    // 设置一个全局的回调函数，用于接收安卓端传回的数据
    window.handleAndroidData = (data) => {
      if (typeof callback === "function") {
        callback(data);
      }
    };
    // 调用安卓的方法
    window.WebAppInterface[androidConfig](params);
  };

  // 公开API
  return {
    callAndroidMethod, // 调用安卓的指定方法
  };
})();

// 导出模块
export default AndroidInterfaceWrapper;
